import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import PilotHero from "../sections/PilotHero";
import PilotIntro from "../sections/PilotIntro";
import FoundingContributor from "../sections/FoundingContributor";
import PilotForm from "../sections/PilotForm";
import PilotFinalVisual from "../sections/PilotFinalVisual";

const PilotPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="Join the BuildEase Pilot — Build With Clarity"
            description="Join the BuildEase pilot for South African homeowners. Help shape a platform that brings clarity to plans, costs, quotations and building decisions."
        />
        <Navbar minimal />
        <main>
            <PilotHero />
            <PilotIntro />
            <FoundingContributor />
            <PilotForm />
            <PilotFinalVisual />
        </main>
        <Footer />
    </div>
);

export default PilotPage;
